import ClearErrorModal from './ClearErrorModal';

export default ClearErrorModal;
